"use strict";
/**
 * StandOut WordPress Theme
 * Template-specific functionality initialization
 * Uses body classes to determine current template
 *
 * @package StandOut
 * @since 2.0.0
 */
// Product cards appear on the archive, in carousels and on application pages —
// keyed on the markup itself rather than on a body class.
if (document.querySelector("[data-card-tags]")) {
    import("./product-card-tags")
        .then((module) => module.watchCardTags())
        .catch((error) => {
        console.error("Failed to load product-card-tags module:", error);
    });
}
const page = document.getElementsByClassName("page-template-default");
if (page.length > 0) {
    import("./page").catch((error) => {
        console.error("Failed to load page template module:", error);
    });
}
const productArchive = document.getElementsByClassName("product-archive");
if (productArchive.length > 0) {
    import("./product-archive").catch((error) => {
        console.error("Failed to load product-archive module:", error);
    });
}
const productSingle = document.getElementsByClassName("product-single");
if (productSingle.length > 0) {
    import("./product-single").catch((error) => {
        console.error("Failed to load product-single module:", error);
    });
}
const heroSlider = document.getElementsByClassName("flexible--hero-slider");
if (heroSlider.length > 0) {
    import("./blocks/hero-slider").catch((error) => {
        console.error("Failed to load hero-slider module:", error);
    });
}
const featuredProducts = document.getElementsByClassName("featured-products");
if (featuredProducts.length > 0) {
    import("./blocks/featured-products").catch((error) => {
        console.error("Failed to load featured-products module:", error);
    });
}
const applicationDetail = document.getElementsByClassName("application-detail");
if (applicationDetail.length > 0) {
    import("./application").catch((error) => {
        console.error("Failed to load application module:", error);
    });
}
const dealerLocator = document.getElementsByClassName("flexible--dealer-locator");
if (dealerLocator.length > 0) {
    import("./blocks/dealer-locator").catch((error) => {
        console.error("Failed to load dealer-locator module:", error);
    });
}
const usps = document.getElementsByClassName("flexible--usps");
if (usps.length > 0) {
    import("./blocks/usps").catch((error) => {
        console.error("Failed to load usps module:", error);
    });
}
const brandValues = document.getElementsByClassName("flexible--brand-values");
if (brandValues.length > 0) {
    import("./blocks/brand-values").catch((error) => {
        console.error("Failed to load brand-values module:", error);
    });
}
const faq = document.getElementsByClassName("flexible--faq");
if (faq.length > 0) {
    import("./blocks/faq").catch((error) => {
        console.error("Failed to load faq module:", error);
    });
}
const storeLocator = document.getElementsByClassName("flexible--store-locator");
if (storeLocator.length > 0) {
    import("./blocks/store-locator").catch((error) => {
        console.error("Failed to load store-locator module:", error);
    });
}
